<template>
<div>
  <el-card>
    <div slot="header" class="clearfix">
      <el-row :gutter="20">
        <el-col :span="20">
          <span style="color: burlywood">{{this.ownerWebTitle}}-定价配置</span>
          <el-button type="text" style="margin-left: 5%;" @click="goToWebSetting">&lt分站信息配置&gt</el-button>
          <span style="color: #44b1eb;margin-left: 5%;">模版选择：</span>
          <el-select v-model="priceMode" clearable placeholder="请选择模版" size="small">
            <el-option
                v-for="item in allPriceMode"
                :key="item.id"
                :label="item.userName"
                :value="item.id"
            >
            </el-option>
          </el-select>
          <el-button type="primary" style="margin-left: 5%;" @click="queryAdminModelData" size="small">获取模版数据</el-button>
        </el-col>
      </el-row>
    </div>
    <el-tabs class="el-tabs-self" v-model="tabsActive">
      <el-tab-pane v-for="(item, index) in tabsActives" :key="index" :label="item.taskName" :name="item.id"></el-tab-pane>
    </el-tabs>
    <saleman-money-data ref="subRefData"
                        :selectMenuValue="selectMenuValue"
                        :saleman-id="salemanId" >
    </saleman-money-data>
  </el-card>
</div>
</template>

<script>
import {getAllTaskType} from "../../api/b2cbusiness/b2c_tasktype";
import SalemanMoneyData from "../../components/SalemanMoneyData";
import {querySalemanWebConfigSetting} from "../../api/b2cbusiness/b2c_customoneysetting";
import {querySalemanPriceModes} from "../../api/b2cbusiness/b2c_saleman";


export default {
name: "SalemanConfigAndSetting",
  components:{
    SalemanMoneyData,
  },
  data(){
    return {
      ownerWebTitle:"分站",
      priceMode:null,
      allPriceMode: [],
      tabsActive: 1,
      tabsActives: []
    }
  },
  mounted() {
    getAllTaskType().then(res => {
      console.log(res.data)
      this.tabsActives = res.data;
    });
    querySalemanPriceModes(2).then(res => {
      if (res.success) {
        this.allPriceMode = res.data;
      }
    });

    querySalemanWebConfigSetting({salemanId:this.$route.query.salemanId}).then(res=>{
      if (res.success){
        this.ownerWebTitle = res.data.webTitle != null?res.data.webTitle:this.ownerWebTitle;
      }
    });
  },
  computed: {
    selectMenuValue(){
      return this.tabsActives.filter(item => item.id == this.tabsActive).pop();
    },
    salemanId(){
      return this.$route.query.salemanId;
    }
  },
  methods:{
    queryAdminModelData(){
      this.$refs.subRefData.queryAdminSubModelData(this.priceMode);
    },
    goToWebSetting(){
      this.$router.push({path:'/home/salemanwebsetting', query:{salemanId:this.$route.query.salemanId}});
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form {
  margin-top: 20px;
}

.el-tabs-self{
  position: relative;
  width: 100%;
}
</style>
